import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { fetchSystemStatus, fetchIndicators } from './api';

const REFRESH_INTERVAL = 15000;

const AppDataContext = createContext({
  systemStatus: null,
  cycleCount: 0,
  lastUpdate: null,
  indicatorsByTf: {},
});

export function AppDataProvider({ children }) {
  const [systemStatus, setSystemStatus] = useState(null);
  const [cycleCount, setCycleCount] = useState(0);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [indicatorsByTf, setIndicatorsByTf] = useState({});

  const poll = useCallback(async () => {
    try {
      const res = await fetchSystemStatus();
      if (res.data) {
        setSystemStatus(res.data);
        setCycleCount(res.data.cycle_count || 0);
        setLastUpdate(res.data.last_update || new Date().toLocaleTimeString());
      }
    } catch {
      /* ignore */
    }
    try {
      const [ind5, ind3] = await Promise.all([
        fetchIndicators('5m'),
        fetchIndicators('3m'),
      ]);
      const next = {};
      if (ind5.data?.data) next['5m'] = ind5.data.data;
      if (ind3.data?.data) next['3m'] = ind3.data.data;
      setIndicatorsByTf(next);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    poll();
    const id = setInterval(poll, REFRESH_INTERVAL);
    return () => clearInterval(id);
  }, [poll]);

  return (
    <AppDataContext.Provider value={{ systemStatus, cycleCount, lastUpdate, indicatorsByTf }}>
      {children}
    </AppDataContext.Provider>
  );
}

export function useAppData() {
  return useContext(AppDataContext);
}
